import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { style } from './alert.styles';

@customElement('sbk-alert')
export class AlertComponent extends LitElement {
    @property({type: String})
    variant: 'error' | 'success' | 'info' | 'lock' = 'success';

    @property({type: String})
    // eslint-disable-next-line lit/no-native-attributes
    title: string = '';

    static get styles() {
        return style;
    }

    private getAlertClass(variant: string): string {
        switch (variant) {
            case 'success':
                return 'alert-success';
            case 'error':
                return 'alert-error';
            case 'info':
                return 'alert-info';
            case 'lock':
                return 'alert-info';
            default:
                return '';
        }
    }

    private getIconForStatus(status: string): string {
        return {
            'error': 'warning',
            'info': 'info',
            'lock': 'lock',
            'success': 'checkmark'
        }[status] || '';
    }

    render() {
        return html`
            <div class="alert ${this.getAlertClass(this.variant)}">
                <div class="icon-wrapper">
                    <sbk-icon size="40" class="alert-icon icon-background" symbol=${this.getIconForStatus(this.variant)}></sbk-icon>
                </div>

                <div class="alert-content">
                    <span class="alert-title">${this.title}</span>
                    <span class="alert-message"><slot></slot></span>
                </div>
            </div>
        `;
    }
}
